(() => {
  'use strict';
  async function completePages(loadPage) {
    let pages = 1, total = null;
    const all = [], ids = new Set();
    for (let page = 1; page <= pages; page++) {
      const batch = await loadPage(page);
      if (!Number.isInteger(batch.pages) || batch.pages < 1 || batch.pages > 100 || !Number.isInteger(batch.total) || batch.total < 0 || batch.total > 25000 || batch.page !== page || batch.pages !== Math.max(1,Math.ceil(batch.total/250))) throw Error('Incomplete collection pagination');
      if (total !== null && (batch.pages !== pages || batch.total !== total)) throw Error('Collection changed during pagination');
      pages = batch.pages; total = batch.total;
      if (batch.items.length !== Math.min(250,total-(page-1)*250)) throw Error('Missing collection candidates');
      for (const item of batch.items) {
        if (!item.id || ids.has(item.id)) throw Error('Duplicate collection candidate');
        ids.add(item.id); all.push(item);
      }
    }
    if (all.length !== total) throw Error('Incomplete collection');
    return all;
  }
  window.LiebmansSchoolRecommendationPages = completePages;
  window.LiebmansSchoolRecommendations = async (c, productLink, previewId) => {
    const section = document.querySelector('[data-liebmans-school-recommendations]');
    if (!section || !c?.complete || !window.LiebmansSchoolEligibility) return;
    section.hidden = true;
    section.dataset.liebmansSchoolRecommendations = c.school;
    const grid = section.querySelector('[data-school-recommendation-cards]');
    grid.replaceChildren();
    try {
      const candidates = await completePages(async page => {
        const url = new URL('/collections/'+c.school,location.origin);
        url.searchParams.set('view','liebmans-recommendations');
        url.searchParams.set('page',String(page));
        const preview = previewId || new URL(location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id',preview);
        const response = await fetch(url,{credentials:'same-origin'});
        if (!response.ok) throw Error('Collection unavailable');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const container = doc.querySelector('[data-school-candidates]');
        if (container?.dataset.schoolCandidates !== c.school) throw Error('Wrong collection');
        return {
          page:Number(container.dataset.page),pages:Number(container.dataset.pages),total:Number(container.dataset.total),
          items:[...container.querySelectorAll('template[data-candidate-id]')].map(t=>({id:t.dataset.candidateId,available:t.dataset.available==='true',template:t}))
        };
      });
      const limit = Math.min(6,Math.max(0,Number(section.dataset.limit)||0));
      const perRow = Number(section.dataset.perRow);
      const widths = {2:'one-half',3:'one-third',4:'one-quarter',5:'one-fifth'};
      for (const item of candidates) {
        if (grid.children.length >= limit) break;
        if (item.id === section.dataset.currentProduct || !item.available) continue;
        const card = item.template.content.querySelector('.grid-product[data-tags]');
        if (!card) throw Error('Missing product card');
        const tags = (card.dataset.tags || '').toLowerCase().split(',').map(t=>t.trim());
        if (!window.LiebmansSchoolEligibility.eligible(tags,c)) continue;
        const copy = document.importNode(card,true);
        copy.classList.remove('medium-up--one-third');
        if (perRow === 2) copy.classList.remove('small--one-half');
        copy.classList.add('medium-up--'+(widths[perRow]||'one-third'));
        copy.dataset.aos = 'row-of-'+perRow;
        copy.querySelectorAll('a').forEach(a=>productLink(a,c));
        grid.append(copy);
      }
      if (grid.children.length) {
        section.hidden = false;
        window.theme?.reinitProductGridItem?.(section);
        document.dispatchEvent(new CustomEvent('recommendations:loaded',{detail:{section}}));
        window.dispatchEvent(new Event('scroll'));
        window.dispatchEvent(new Event('resize'));
      }
      section.dataset.verification = 'complete';
    } catch (_) {
      grid.replaceChildren(); section.hidden = true; section.dataset.verification = 'unavailable';
    }
  };
})();
